import React from 'react';
import { ChevronDoubleRight,ChevronDoubleLeft,ChevronRight,ChevronLeft} from 'react-bootstrap-icons';

const defaultProps = {
    initialPage: 1,
    pageSize: 10
}   

class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = { pager: {} };
    }

    componentWillMount() {
        if (this.props.items && this.props.items.length) {
            this.setPage(this.props.initialPage);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        
        if (this.props.items !== prevProps.items || this.props.pageSize !== prevProps.pageSize) {
            this.setPage(this.props.currentPg);
        }
    }

    setPage(page) {
        var { items, pageSize } = this.props;
        var pager = this.getPager(items.length, page, pageSize);
        if ( (page < 1 || page > pager.totalPages) && pager.pages.length > 0) {
            return;
        }

        this.setState({ pager: pager });
        this.props.onChangePage(page);
    }

    getPager(totalItems, currentPage, pageSize) {

        currentPage = currentPage || 1;
        pageSize = pageSize || nPagesShow;

        var nPagesShow = 6;
        var totalPages = Math.ceil(totalItems / pageSize);
        var startPage, endPage;

        if (totalPages <= nPagesShow) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 4) {
                startPage = 1;
                endPage = nPagesShow;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 5;
                endPage = totalPages;
            } else {
                startPage = currentPage - 3;
                endPage = currentPage + 2;
            }
        }

        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

        const obj = {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
        
        return obj;
    }

    render() {
        var pager = this.state.pager;
        var arQtdRow = this.props.qtdRowPage;

        if (!pager.pages || pager.pages.length < 1) {
            return null;
        }
        
        return (
            <>
                <div className="width-responsive resp-row d-flex justify-content-between">
                    <div className="pagination-info resp-mr-3 width-responsive-row text-center rounded">{this.props.items.length} Registros</div>
                    <div>
                        <select className="pagination-info-select width-responsive-row text-center rounded" onChange={(event) => this.props.setRowPage(event.target.value)} title="Registros por pagina">
                            {arQtdRow?.map((qtdRow) => {
                                return <option value={qtdRow}>{qtdRow}/página</option>
                            })}
                        </select>
                    </div>
                </div>
                <ul className="pagination-responsive width-responsive">
                    <li className={pager.currentPage === 1 ? 'disabled util' : 'util'} title="Primero">
                        <a class="rounded" onClick={() => this.setPage(1)}><b><ChevronDoubleLeft /></b></a>
                    </li>
                    <li className={pager.currentPage === 1 ? 'disabled util' : 'util'} title="Anterior">
                        <a class="rounded" onClick={() => this.setPage(pager.currentPage - 1)}><b><ChevronLeft /></b></a>
                    </li>
                    {pager.pages.map((page, index) =>
                        <li key={index} className={pager.currentPage === page ? 'active' : ''}>
                            <a class="rounded" onClick={() => this.setPage(page)}>{page}</a>
                        </li>
                    )}
                    <li className={pager.currentPage === pager.totalPages ? 'disabled util' : 'util'} title="Próximo">
                        <a class="rounded" onClick={() => this.setPage(pager.currentPage + 1)}><b><ChevronRight /></b></a>
                    </li>
                    <li className={pager.currentPage === pager.totalPages ? 'disabled util' : 'util'} title="Último">
                        <a class="rounded" onClick={() => this.setPage(pager.totalPages)}><b><ChevronDoubleRight /></b></a>
                    </li>
                </ul>
            </>
        );
    }
}

Pagination.defaultProps = defaultProps;
export default Pagination;
